/**
 * The SoundDAO mark (public/brand/mark.png), sized to the surrounding font size so it drops
 * into any spot that used the 🎵 emoji as the logo. Decorative: the wordmark text sits beside it.
 */
import React from 'react';

export default function BrandMark({ size = '1em', style }) {
  return (
    <img
      src="/brand/mark.png"
      alt=""
      aria-hidden="true"
      className="brand-mark"
      style={{ height: size, width: 'auto', verticalAlign: '-0.15em', ...style }}
    />
  );
}
